import { useQuery } from "@tanstack/react-query";
import axios from "const/axios";

export const getPaginatedCourseData = async ({
  page = 0,
  size = 20,
  search,
  universityId,
} = {}) => {
  const res = await axios.get("courses/with-offerings/page", {
    params: {
      page,
      size,
      ...(search ? { search } : {}),
      ...(universityId != null ? { universityId } : {}),
    },
  });
  return res?.data?.data;
};

export const useCourseById = (courseId, options = {}) =>
  useQuery({
    queryKey: ["course-with-offerings", courseId],
    queryFn: async () => {
      const res = await axios.get(`courses/with-offerings/${courseId}`);
      return res?.data?.data ?? null;
    },
    enabled: Boolean(courseId),
    refetchOnWindowFocus: false,
    ...options,
  });
